import{u as e}from"./useThemeWithoutDefault-a80ff69c.js";import{c as t}from"./createTheme-c3f66f95.js";const r=t();function o(t=r){return e(t)}export{o as u};
